export enum ListSortMode {
    PER_VALUE = 'perValue',
    PER_ORIGIN_ORDER = 'perOriginOrder',
}